import { render, staticRenderFns } from "./Game3-12.vue?vue&type=template&id=559cb770&scoped=true&"
import script from "./Game3-12.vue?vue&type=script&lang=js&"
export * from "./Game3-12.vue?vue&type=script&lang=js&"
import style0 from "./Game3-12.vue?vue&type=style&index=0&id=559cb770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559cb770",
  null
  
)

export default component.exports